import { TextField } from "@mui/material"
import { Euro } from "@mui/icons-material"

export default function Price({label, value, onChange, required}){

    return <TextField
        label={label || 'Prix'}
        type="number"
        onChange={onChange}
        value={value}
        InputProps={{
            inputProps: {min: 0, step: 0.01},
            endAdornment: <Euro color='action'/>
        }}
        required={required ? true : false}
        size='small'
    />
}